import FederacionService from '../../services/FederacionService'

const state = {
  federaciones: [],
  federacion: null,
  totalItems: 0,
  currentPage: 1,
  itemsPerPage: 20
}

const getters = {
  federaciones: state => state.federaciones,
  federacion: state => state.federacion,
  totalItems: state => state.totalItems,
  currentPage: state => state.currentPage,
  itemsPerPage: state => state.itemsPerPage
}

const actions = {
  async fetchFederaciones({ commit, state }, { page = 1, limit, filters = {} }) {
    try {
      const itemsPerPage = limit || state.itemsPerPage
      if (limit) {
        commit('setItemsPerPage', limit)
      }
      const response = await FederacionService.getFederaciones(page, itemsPerPage, filters)
      commit('setFederaciones', response.data.data)
      commit('setTotalItems', response.data.data?.length || 0)
      commit('setCurrentPage', page)
      return response
    } catch (error) {
      throw error
    }
  },

  async fetchFederacion({ commit }, id) {
    try {
      const response = await FederacionService.getFederacion(id)
      commit('setFederacion', response.data.data)
      return response
    } catch (error) {
      throw error
    }
  },

  async createFederacion({ commit }, federacion) {
    try {
      const response = await FederacionService.createFederacion(federacion)
      return response
    } catch (error) {
      throw error
    }
  },

  async updateFederacion({ commit }, { id, federacion }) {
    try {
      const response = await FederacionService.updateFederacion(id, federacion)
      return response
    } catch (error) {
      throw error
    }
  },

  async deleteFederacion({ commit }, id) {
    try {
      const response = await FederacionService.deleteFederacion(id)
      return response
    } catch (error) {
      throw error
    }
  },

  async exportarListado({ commit }, { formato, filtros }) {
    try {
      const response = await FederacionService.exportarListado(formato, filtros)
      return response
    } catch (error) {
      throw error
    }
  }
}

const mutations = {
  setFederaciones(state, federaciones) {
    state.federaciones = federaciones
  },
  setFederacion(state, federacion) {
    state.federacion = federacion
  },
  setTotalItems(state, total) {
    state.totalItems = total
  },
  setCurrentPage(state, page) {
    state.currentPage = page
  },
  setItemsPerPage(state, itemsPerPage) {
    state.itemsPerPage = itemsPerPage
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}